import { useTranslation } from 'react-i18next'
import { AddDebt } from '~/features/Debt/AddDebt'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { PageContainer, PageTitle, Container } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'debts', link: '/debts' },
  { titleI18n: 'new debt' },
]

export function AddDebtPage() {
  const { t } = useTranslation()
  return (
    <PageContainer title={t('new debt')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('new debt')}</PageTitle>
      </Container>

      <AddDebt />
    </PageContainer>
  )
}
